var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"size":"20","color":_vm.value ? 'green' : 'red'}},[_vm._v(" "+_vm._s(_vm.value ? 'mdi-checkbox-marked-circle' : 'mdi-close-circle-outline')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }